<template>
    <footer class="footer">
            <div class="container">
                <div class="content has-text-centered">
                    <p>
                        <strong>SyncOn</strong> by <a href="https://github.com/nmelihsensoy/syncOn.live">nmelihsensoy</a>
                    </p>
                </div>
            </div>
    </footer>
</template>

<script>
export default {
    
}
</script>

<style>
    
</style>
